interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="67"
    height="52"
    viewBox="0 0 67 52"
    fill="none"
  >
    <path
      d="M55.0039 24.9397V3.90179C55.0039 2.29743 53.7065 1 52.1021 1H3.90179C2.29743 1 1 2.29743 1 3.90179V41.5413C1 43.5363 2.6183 45.1546 4.61328 45.1546H38.4582"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25446 5.93861C8.25446 5.65959 8.03125 5.43637 7.75223 5.43637C7.47321 5.43637 7.25 5.65959 7.25 5.93861C7.25 6.21762 7.47321 6.44084 7.75223 6.44084C8.03125 6.44084 8.25446 6.21762 8.25446 5.93861Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0439 5.93861C14.0439 5.65959 13.8207 5.43637 13.5417 5.43637C13.2626 5.43637 13.0394 5.65959 13.0394 5.93861C13.0394 6.21762 13.2626 6.44084 13.5417 6.44084C13.8207 6.44084 14.0439 6.21762 14.0439 5.93861Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8338 5.93861C19.8338 5.65959 19.6106 5.43637 19.3316 5.43637C19.0526 5.43637 18.8293 5.65959 18.8293 5.93861C18.8293 6.21762 19.0526 6.44084 19.3316 6.44084C19.6106 6.44084 19.8338 6.21762 19.8338 5.93861Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 10.933H55.0039"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.8522 46.731L41.4576 51V32.5011C41.4576 29.976 43.4945 27.9392 46.0196 27.9392H61.5888C64.1139 27.9392 66.1507 29.976 66.1507 32.5011V42.1691C66.1507 44.6942 64.1139 46.731 61.5888 46.731H45.8661H45.8522Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.9911 34.7472H58.9102"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.9911 39.4766H58.9102"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVG;
